export const EDUCATION_AREAS = [
  "Книги",
  "Настільні ігри",
  "Письмове приладдя",
  "Папір та блокноти",
  "Офісне приладдя",
  "Папки та файли",
  "Шкільне приладдя",
  "Мовні матеріали",
  "Курси / Навчання",
  "Інше",
];

const BOOK_GENRES = [
  "Художні",
  "Бізнес",
  "Наукові",
  "Психологія",
  "Підручники / Посібники",
  "Енциклопедії / Словники",
  "Кулінарія",
  "Історія",
  "Дитячі",
];
const BOOK_FORMATS = ["Друкована", "Електронна (ePub/PDF)", "Аудіокнига"];

const BOARDGAME_TYPES = [
  "Сімейні",
  "Стратегічні",
  "Паті-ігри",
  "Дитячі",
  "Карткові",
  "Рольові / Кооперативні",
];

const LANGUAGES = [
  "Англійська",
  "Німецька",
  "Французька",
  "Іспанська",
  "Польська",
  "Українська для іноземців",
  "Інші мови",
];
const LANGUAGE_MATERIAL_TYPES = [
  "Підручники / Посібники",
  "Робочі зошити",
  "Картки / Флеш-карти",
  "Розмовники",
  "Аудіо / Відео",
  "Ігри для вивчення",
];

const COURSE_FORMATS = ["Онлайн", "Офлайн"];
const COURSE_TOPICS = [
  "Мови",
  "IT",
  "Бізнес / Маркетинг",
  "Дизайн / Креатив",
  "Шкільна програма",
  "Музика / Мистецтво",
  "Спорт / Фітнес",
  "Інше",
];

const SECTIONS_BY_AREA = {
  "Книги": BOOK_GENRES,

  "Настільні ігри": [],

  "Письмове приладдя": [
    "Ручки / Маркери",
    "Олівці / Графіт",
    "Лінійки / Циркулі",
    "Гумки / Коректори",
    "Ножиці / Ножі",
    "Клей / Скотч",
  ],
  "Папір та блокноти": [
    "Офісний папір",
    "Щоденники / Планери",
    "Блокноти / Нотатники",
    "Папір для нотаток",
    "Кольоровий папір / Картон",
    "Календарі",
    "Листівки / Конверти",
    "Фотоальбоми",
    "Бланки / Журнали обліку",
  ],
  "Офісне приладдя": [
    "Настільні органайзери",
    "Степлери / Скоби",
    "Діркопробивачі",
    "Кнопки / Скріпки",
    "Клейкі матеріали / Скотч",
    "Калькулятори",
  ],
  "Папки та файли": ["Папки", "Файли / Обкладинки", "Реєстратори", "Швидкозшивачі"],
  "Шкільне приладдя": [
    "Зошити",
    "Пенали",
    "Обкладинки",
    "Пластилін / Ліплення",
    "Фломастери / Маркери / Олівці",
    "Щоденники",
    "Закладки / Стікери",
  ],

  "Мовні матеріали": LANGUAGES,

  "Курси / Навчання": COURSE_FORMATS,

  "Інше": ["Інше навчальне"],
};

const SUBCATS_BY_SECTION = {
  "Ручки / Маркери": [],
  "Олівці / Графіт": [],
  "Лінійки / Циркулі": [],
  "Гумки / Коректори": [],
  "Ножиці / Ножі": [],
  "Клей / Скотч": [],
  "Офісний папір": [],
  "Щоденники / Планери": [],
  "Блокноти / Нотатники": [],
  "Папір для нотаток": [],
  "Кольоровий папір / Картон": [],
  "Календарі": [],
  "Листівки / Конверти": [],
  "Фотоальбоми": [],
  "Бланки / Журнали обліку": [],
  "Настільні органайзери": [],
  "Степлери / Скоби": [],
  "Діркопробивачі": [],
  "Кнопки / Скріпки": [],
  "Клейкі матеріали / Скотч": [],
  "Калькулятори": [],
  "Папки": [],
  "Файли / Обкладинки": [],
  "Реєстратори": [],
  "Швидкозшивачі": [],
  "Зошити": [],
  "Пенали": [],
  "Обкладинки": [],
  "Пластилін / Ліплення": [],
  "Фломастери / Маркери / Олівці": [],
  "Щоденники": [],
  "Закладки / Стікери": [],

  "Онлайн": COURSE_TOPICS,
  "Офлайн": COURSE_TOPICS,

  "Інше навчальне": [],
};

BOOK_GENRES.forEach((g) => {
  SUBCATS_BY_SECTION[g] = BOOK_FORMATS;
});

LANGUAGES.forEach((lang) => {
  SUBCATS_BY_SECTION[lang] = LANGUAGE_MATERIAL_TYPES;
});

export const educationFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Сфера / Категорія *",
      type: "select",
      options: EDUCATION_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  if (area === "Настільні ігри") {
    return areaOnly;
  }

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
